import Service from "../../../Services/index";

const Seller = {
    namespaced: true,
    state: {
        data: [],
        replace_data: [],
        customer_sale : []
    },
    mutations: {
        GET_SELLER: (state, res) => {
            state.data = res;
        },
        REPLACE_SELLER: (state, res) => {
            state.replace_data = res;
        },
        GO_TO_SELLER: (state, res) => {
            state.goToSeller = res;
        },
        GET_CUSTOMER_FROM_SALE:(state,res)=>{
            state.customer_sale = res;
        },
    },
    actions: {
        get({ commit }) {
            return Service.seller
                .getSeller()
                .then(response => {
                    commit("GET_SELLER", response);
                })
        },
        show({ commit }, id) {
            return Service.seller
                .showSeller(id)
                .then(response => {
                    commit("REPLACE_SELLER", response);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        create({ commit }, data) {
            return Service.seller
                .createSeller(data)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        update({ commit }, { id, data }) {
            return Service.seller
                .updateSeller(id, data)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        delete({ commit }, id) {
            return Service.seller
                .deleteSeller(id)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        search({ commit }, keyword) {
            return Service.seller.searchSeller(keyword).then(response => {
                commit("GET_SELLER", response);
            });
        },
        getCustomerFromSale({commit},data){
            console.log(data);
            return Service.seller.getCustomerFromSale(data).then(res=>{
                commit("GET_CUSTOMER_FROM_SALE",res);
            })
        }
    }
};

export default Seller;
